import { useEffect, useState } from "react";
import { ContentState, EditorState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const MyEditor = ({ content, setContent }: { content: string; setContent: Function }) => {
    const [editorState, setEditorState] = useState<EditorState>(EditorState.createEmpty());

    useEffect(() => {
        if (content) {
            try {
                const blocksFromHTML = convertFromHTML(content);
                if (blocksFromHTML.contentBlocks) {
                    const contentState = ContentState.createFromBlockArray(
                        blocksFromHTML.contentBlocks,
                        blocksFromHTML.entityMap
                    );
                    setEditorState(EditorState.createWithContent(contentState));
                }
            } catch (error) {
                console.error("Error al cargar contenido en el editor:", error);
            }
        }
    }, [content]);

    const handleEditorChange = (state: EditorState) => {
        setEditorState(state);

        // Exportar correctamente incluyendo subíndices y superíndices
        const htmlContent = stateToHTML(state.getCurrentContent(), {
            inlineStyles: {
                SUPERSCRIPT: { element: "sup" },
                SUBSCRIPT: { element: "sub" },
            },
        });

        setContent(htmlContent);
    };

    const toolbar = {
        options: ["inline", "list", "textAlign", "history"],
        inline: {
            inDropdown: false,
            options: [
                "bold",
                "italic",
                "underline",
                "strikethrough",
                "monospace",
                "superscript",
                "subscript",
            ],
        },
    };

    const fontSizeOptions = [8, 10, 12, 14, 16, 18, 24, 30, 36];

    const customStyleMap = {
        ...fontSizeOptions.reduce((styles, size) => {
            styles[`FONT_SIZE_${size}`] = { fontSize: `${size}px` };
            return styles;
        }, {} as Record<string, any>),

        SUPERSCRIPT: { verticalAlign: "super", fontSize: "smaller" },
        SUBSCRIPT: { verticalAlign: "sub", fontSize: "smaller" },
    };


    return (
        <div style={{ position: "relative", width: "100%", border: "1px solid #ccc", padding: "10px" }}>
            {/* Selector de tamaño de fuente */}
            {/* <select
                onChange={(e) => applyFontSize(Number(e.target.value))}
                style={{ marginBottom: "10px", padding: "5px", borderRadius: "5px" }}
            >
                <option value="">Tamaño</option>
                {fontSizeOptions.map((size) => (
                    <option key={size} value={size}>
                        {size}px
                    </option>
                ))}
            </select> */}

            {/* Editor de texto */}
            <Editor
                editorState={editorState}
                onEditorStateChange={handleEditorChange}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                toolbar={toolbar}
                customStyleMap={customStyleMap}
                textAlignment="left"
                localization={{ locale: "es" }}
            />
        </div>
    );
};

export default MyEditor;
